// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__7fg8Q","content":"LoadingAlert_content__2W4sJ"};